<script>
    import { createEventDispatcher, getContext } from 'svelte'
    import { fly } from 'svelte/transition';
    import { quadIn } from 'svelte/easing';
    import SidebarButton from './SidebarButton.svelte'
    // import { Router, Link, Route, navigate } from 'svelte-routing'
    import { Router, Route, Link, navigateTo } from 'yrv';
    import NavLink from '../NavLink/NavLink.svelte'
    import userStore from '../../stores/user'
    // import UserAvatar from '../UserAvatar/UserAvatar.svelte'
    
    export let background
    export let appbusy
    export let search = false
    export let currentView = ''
    export let currentSubview = ''

    let activeFeatures = null;

    const dispatch = createEventDispatcher ();
    const isMobile = getContext ('mobileDevice');
    const openView = (viewid) => {
        dispatch ('viewchange', {
            id: viewid
        })
    }
    const openSubview = (subviewId) => {
        dispatch ('subviewchange', {
            id: subviewId
        })
    }
    const logoutApp = () => {
        dispatch ('action', { id: 'logout' })
    }

    const searchInApp = () => {
        const searchSetting = !search;
        dispatch ('action', { id: 'search', value: searchSetting })
    }

    const closeSearch = () => {
        dispatch ('action', { id: 'search', value: false })
    }

    const loadActiveFeatures = () => {
        activeFeatures = $userStore.activeFeatures.length > 0 ? $userStore.activeFeatures : null;
    }

    const isActiveFeature = (name, features) => {
        return activeFeatures ? activeFeatures.includes(name) : true;
    }

    $: if ($userStore.activeFeatures) {
        loadActiveFeatures();
    }
</script>


<!-- <div style="position: fixed;right: 20px;top: 20px;">
    {$userStore.name}
</div> -->
<div class="Sidebar" class:mobile={isMobile}>
    <div class="logo">
        <Link href="/app" on:click={closeSearch}>
            {#if $userStore.sector}
                <i class="fad {$userStore.sector.icon}"></i>
            {:else}
                <i class="fad fa-rocket"></i>
            {/if}
        </Link>
    </div>
    <div class="menu">
        {#if isActiveFeature('CLIENTS', activeFeatures)}
            <Link href="/app/clients">
                <SidebarButton 
                    type="ghost" 
                    active={currentView === 'clients'} 
                    tooltip="Clienti" icon="far fa-users" tabindex="-1" />
            </Link>
        {/if}
        
        {#if $userStore.sector}
            <div class="submenu" in:fly={{ y: -40, duration: 300, delay: 100 }}>
                {#if isActiveFeature('DASHBOARD', activeFeatures)}
                    <Link href={"/app/dashboard/" + $userStore.sector.id} on:click={closeSearch}>
                        <SidebarButton 
                            type="ghost" 
                            tooltip="Dashboard" icon="far fa-tachometer" tabindex="-1" />
                    </Link>
                {/if}
                {#if isActiveFeature('OPERATORS', activeFeatures)}
                    <Link href={"/app/operators/" + $userStore.sector.id} on:click={closeSearch}>
                        <SidebarButton 
                            type="ghost" 
                            tooltip="Operatori" icon="far fa-user-hard-hat" tabindex="-1" />
                    </Link>
                {/if}
                {#if isActiveFeature('VACATIONS', activeFeatures)}
                    <Link href={"/app/vacations/" + $userStore.sector.id} on:click={closeSearch}>
                        <SidebarButton 
                            type="ghost" 
                            tooltip="Gestione Ferie / Permessi" icon="far fa-umbrella-beach" tabindex="-1" />
                    </Link>
                {/if}
                {#if isActiveFeature('PROGRAMS', activeFeatures)}
                    <Link href={"/app/programs/" + $userStore.sector.id} on:click={closeSearch}>
                        <SidebarButton 
                            type="ghost" 
                            tooltip="Programmi" icon="far fa-history" tabindex="-1" />
                    </Link>
                {/if}
                {#if isActiveFeature('ALERTS', activeFeatures)}
                    <Link href={"/app/alerts/" + $userStore.sector.id} on:click={closeSearch}>
                        <SidebarButton 
                            type="ghost" 
                            tooltip="Alert" icon="far fa-bell-on" tabindex="-1" />
                    </Link>
                {/if}
                {#if isActiveFeature('QUERY', activeFeatures)}
                    <Link href={"/app/query/" + $userStore.sector.id} on:click={closeSearch}>
                        <SidebarButton 
                            type="ghost" 
                            tooltip="Query Attività" icon="far fa-search" tabindex="-1" />
                    </Link>
                {/if}

                <!-- <SidebarButton type="ghost" on:click={searchInApp} active={search} 
                    tooltip={search ? "Chiudi ricerca" : "Cerca"} icon="far fa-search" tabindex="-1" /> -->
                
        
                
            </div>
        {/if}


    </div>

    <div class="bottom">
        {#if background}
            <div class="loading">
                <i class="fad fa-spinner-third fa-spin"></i>
            </div>
        {/if}
        <SidebarButton type="ghost" on:click={logoutApp} 
            tooltip="Logout {$userStore.name}" icon="far fa-power-off" tabindex="-1" />
    </div>
    {#if appbusy}
        <div class="sidebarbusy"></div>
    {/if}
</div>

<style>
    .Sidebar {
        position: fixed;
        top: 0;
        left: 0;
        width: 50px;
        height: 100%;
        background-color: #2c3d4c;
        color: #fff;
        font-size: 18px;
        z-index: 40;
    }

    .Sidebar .menu {
        display: inline-block;
        line-height: 50px;
        text-align: center;
        color: #81ecec;
    }
    .Sidebar .submenu {
        display: inline-block;
    }
    .Sidebar .menu :global(a), .Sidebar .submenu :global(a) {
        vertical-align: top;
    }

    .Sidebar .logo {
        display: inline-block;
        position: relative;
        width: 50px;
        height: 55px;
        line-height: 55px;
        font-size: 22px;
        text-align: center;
        vertical-align: top;
        /* color: #81ecec; */
        
        color: #81ecec;
        margin-bottom: 5px;
    }
    .Sidebar .logo :global(a) {
        display: inline-block;
        width: 50px;
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: #81ecec;
    }

    

    .Sidebar .arrow {
        color: #94b7c1;
    }

    .Sidebar .bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .Sidebar :global(.SidebarButton.subview) {
        display: inline-block;
        text-align: center;
        padding: 0;
        border: 0;
        background-color: transparent;
    }

    .Sidebar :global(.SidebarButton.subview .icon) {
        position: relative;
        font-size: 16px;
    }
    .Sidebar :global(.SidebarButton.subview .icon::after) {
        content: "";
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        height: 40px;
        z-index: -1;
        border-radius: 50%;
        background-color: #4d636d;
        transform: translate(-50%, -50%);
    }
    .Sidebar .loading {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #56f7bf;
        font-size: 22px;
    }

    .Sidebar .sidebarbusy {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgb(44, 61, 76, .7);
    }
    

    :global(.App.brand-0) .Sidebar .logo :global(a), 
    :global(.App.brand-0) .Sidebar .loading {
        color: var(--brand-0-color-sidebar-logo);
    }
    :global(.App.brand-1) .Sidebar .logo :global(a), 
    :global(.App.brand-1) .Sidebar .loading {
        color: var(--brand-1-color-sidebar-logo);
    }

    .Sidebar :global(a[aria-current="page"]) :global(.SidebarButton) {
        background-color: var(--forge-action-primary-bg);
    }

    :global(.App.brand-0) .Sidebar :global(a[aria-current="page"]) :global(.SidebarButton) {
        background-color: var(--brand-0-color-sidebar-selected)
    }
    :global(.App.brand-0) .Sidebar :global(.SidebarButton:hover), 
    :global(.App.brand-0) .Sidebar :global(.SidebarButton:active) {
        background-color: var(--brand-0-color-sidebar-hover)
    }
    :global(.App.brand-0) .Sidebar :global(.SidebarButton.active) {
        background-color: var(--brand-0-color-sidebar-selected)
    }

    :global(.App.brand-1) .Sidebar :global(a[aria-current="page"]) :global(.SidebarButton) {
        background-color: var(--brand-1-color-sidebar-selected)
    }
    :global(.App.brand-1) .Sidebar :global(.SidebarButton:hover), 
    :global(.App.brand-1) .Sidebar :global(.SidebarButton:active) {
        background-color: var(--brand-1-color-sidebar-hover)
    }
    :global(.App.brand-1) .Sidebar :global(.SidebarButton.active) {
        background-color: var(--brand-1-color-sidebar-selected)
    }

    .Sidebar.mobile {
        width: 100%;
        height: 50px;
    }
    .Sidebar.mobile .bottom {
        width: 50px;
        bottom: 0;
        right: 0;
        left: unset;
    }
    .Sidebar.mobile .menu {
        line-height: 50px;
        text-align: left;
        display: none;
    }

    .Sidebar.mobile .logo {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        margin-right: 5px;
        margin-bottom: 0;
    }
    .Sidebar.mobile .logo :global(a) {
        display: inline-block;
        width: 50px;
        height: 50px;
        line-height: 50px;
    }
</style>